module.exports = __webpack_public_path__ + "img/tower_dire.3fbd6469.png";